export const TEE_READ = "teesheet.read";
export const TEE_BOOK = "teesheet.book";
export const TEE_MANAGE = "teesheet.manage";
export const TEE_OVERRIDE = "teesheet.override";
